import { render, staticRenderFns } from "./VacunaNombreMujer.vue?vue&type=template&id=2d0b3a37&scoped=true"
import script from "./VacunaNombreMujer.vue?vue&type=script&lang=js"
export * from "./VacunaNombreMujer.vue?vue&type=script&lang=js"
import style0 from "./VacunaNombreMujer.vue?vue&type=style&index=0&id=2d0b3a37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0b3a37",
  null
  
)

export default component.exports